import React from 'react'

import { Banner } from './Banner'
import { Post } from './Post'
import { Queue } from './Queue'
import { ProgressBar } from './ProgressBar'
import { ProcessingCard } from './ProcessingCard'
import { CompletedCard } from './CompletedCard'
import { useLumi } from './hooks/useLumi'
import { Stage } from './context/LumiContext.types'
import * as S from './lumi.styles'

export const Lumi = () => {
    const { stage } = useLumi()

    return (
        <S.LumiWrapper stage={stage}>
            {stage === Stage.Processing && <ProgressBar />}

            <Banner />

            {stage === Stage.Init && (
                <>
                    <Post />

                    <Queue />
                </>
            )}

            {stage === Stage.Processing && <ProcessingCard />}

            {stage === Stage.Completed && <CompletedCard />}
        </S.LumiWrapper>
    )
}
